import PropTypes from "prop-types"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import StatusTag from "pagesV2/pro/clients/ClientDetails/ClientDetailsTabs/BookingTab/BookingTable/StatusTag"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"

const UpcomingBookingItem = ({ booking }) => {
  const { t } = useTranslation()
  const { experience_date, trip_title, full_name } = booking || {}
  const startTime = booking?.experience_time?.start_time
  const endTime = booking?.experience_time?.end_time

  return (
    <Card className={styles.bookingItem}>
      <Flex vertical gap={spacings.XS}>
        <Flex justify="space-between" align="center">
          <Text fw="600" size="md">
            {experience_date} {startTime && endTime ? ` ${startTime} - ${endTime}` : ""}
          </Text>
          <StatusTag status={t("client.booking.status.upcoming")} />
        </Flex>
        <Text>{trip_title}</Text>
        <Text fw="600" size="md">
          {full_name}
        </Text>
      </Flex>
    </Card>
  )
}

UpcomingBookingItem.propTypes = {
  booking: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
    title: PropTypes.string,
    guest: PropTypes.string,
    experience_time: PropTypes.shape({
      start_time: PropTypes.string,
      end_time: PropTypes.string
    })
  })
}

export default UpcomingBookingItem
